import { render, staticRenderFns } from "./EditDestination.vue?vue&type=template&id=602baa1a&v-on-clickaway=cancel&"
import script from "./EditDestination.vue?vue&type=script&lang=ts&"
export * from "./EditDestination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports